import { getVariableByEnv } from "@Utils/variableByEnv";

export default class FacebookApiProvider {
  getFacebookLoginToken = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      return FB.login(
        (response) => {
          const token =
            response.authResponse != null ? response.authResponse.accessToken : undefined;

          if (token) {
            return resolve(token);
          } else {
            return reject({
              response: {
                data: {
                  error_description: ["The token can't be retrieved"],
                },
              },
            });
          }
        },
        { scope: "public_profile,email,user_photos" }
      );
    });
  };

  load = (): void => {
    window.fbAsyncInit = () =>
      FB.init({
        appId: window.cheerzConfigs
          ? window.cheerzConfigs.facebook.appId // This is only useful while some pages are still on cheerz
          : getVariableByEnv("REACT_APP_FACEBOOK_APP_ID"),
        version: "v8.0",
        xfbml: true,
      });
  };
}
